import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Github, Twitter, Linkedin } from "lucide-react";
import { Crest } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-slate-300 mt-24">
      <div className="h-1 gov-stripe" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white rounded-lg p-1">
              <Crest size={48} />
            </div>
            <div>
              <div className="text-white font-black text-2xl tracking-tight">KELTA</div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-400">
                Kerala Local Body Technical Assistants Association
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-md">
            Connecting people. Empowering governance. Enabling Digital Kerala. The official network
            of technical assistants serving local self-governments across the state.
          </p>
          <div className="flex gap-3 mt-6">
            <SocialLink Icon={Twitter} />
            <SocialLink Icon={Linkedin} />
            <SocialLink Icon={Github} />
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Portal</div>
          <ul className="space-y-2 text-sm">
            <FooterLink to="/register">Join Membership</FooterLink>
            <FooterLink to="/login">Member Login</FooterLink>
            <FooterLink to="/knowledge">Knowledge Base</FooterLink>
            <FooterLink to="/events">Events</FooterLink>
            <FooterLink to="/helpdesk">Help Desk</FooterLink>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</div>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-brand-orange" />
              <span>
                KELTA Office<br />
                M.P Building, 12/79 D,<br />
                Vellalassery P.O, N.I.T Via,<br />
                Kozhikode – 673601
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-brand-orange" />
              <span>keltastate@gmail.com</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-brand-orange" />
              <span>+91 471 000 0000</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} KELTA. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/refund" className="hover:text-white">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }) {
  return <li><Link to={to} className="text-slate-400 hover:text-white transition-colors">{children}</Link></li>;
}

function SocialLink({ Icon }) {
  return (
    <a href="#" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 flex items-center justify-center transition-colors">
      <Icon className="w-4 h-4" />
    </a>
  );
}
